/**
 *
 * @author Matthew Rawson @ 14/08/2018 14:57
 * @description
 * @notes
 */
import React from "react"
import PropTypes from "prop-types"
import {Route} from "react-router-dom"

import {NestedRoute, IndexRedirect} from "@irati/utils/history/routing"
import {HasPermissionTo} from "@irati/utils/permissions"

import {WizardStep1, WizardStep2, WizardStep3} from "../pages"
import sitemap from "../sitemap"


const WizardRoutes = ({match}) => {
  return (
    <Route
      path={match.path}
      render={() => (
        <HasPermissionTo permissions={["insights.schedules", "insights.wizard"]}>

          <NestedRoute match={match.path} {...sitemap.wizardStep1} component={WizardStep1} useGrid={false} />
          <NestedRoute match={match.path} {...sitemap.wizardStep2} component={WizardStep2} useGrid={false} />
          <NestedRoute match={match.path} {...sitemap.wizardStep3} component={WizardStep3} useGrid={false} />
          <IndexRedirect match={match} to={sitemap.wizardStep1.path} />

        </HasPermissionTo>
      )} />
  )
}


WizardRoutes.propTypes = {
  match: PropTypes.object.isRequired
}
WizardRoutes.defaultProps = {}

export default WizardRoutes
